import React from 'react';
import Button from '../Button';
import MButton from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import get from 'lodash/get';
import { List } from 'immutable';

const styles = theme => ({
  root: {},
  dNone: {
    display: 'none',
  },
  popper: { textAlign: 'right' },
  popContent: { overflow: 'hidden' },
  typography: {
    padding: theme.spacing(2),
  },
});

function FileInput(props) {
  const {
    classes,
    icon,
    label = 'Upload File',
    onSelect,
    accept,
    color,
    multiple = false,
    triggerOnMount,
    disabled,
  } = props;
  const inputEl = React.useRef(null);
  const btnEl = React.useRef(null);
  const [fileList, setFileList] = React.useState(List([]));
  // const [popOpened, setPopOpened] = React.useState(null);
  const files = React.useMemo(() => fileList.toArray(), [fileList]);
  // let open = multiple && files.length > 0;
  // if (popOpened !== null) {
  //   open = popOpened;
  // }
  let open = false;
  const ppId = open ? 'no-transition-popper' : null;
  console.log('open', open); //TRACE
  React.useEffect(() => {
    // if (multiple) return;
    const fdata = multiple ? files : files[0];
    onSelect && onSelect(fdata);
  }, [files]);

  React.useLayoutEffect(() => {
    if (btnEl && triggerOnMount) {
      inputEl.current.click();
    }
  }, []);

  React.useEffect(() => {
    if (files.length === 0) {
      inputEl.current.value = null;
      // setPopOpened(null);
    }
  }, [files]);

  const onClick = React.useCallback(() => {
    if (inputEl) inputEl.current.click();
  }, [inputEl]);
  const clearFile = React.useCallback(() => {
    if (files.length > 0) {
      setFileList(List([]));
    } else {
      // setPopOpened(!open);
    }
  }, [multiple, files]);

  const onFileChanged = React.useCallback(
    evt => {
      const tfiles = get(evt, 'target.files', []);
      // const fdata = multiple ? tfiles : tfiles[0];
      setFileList(List(Array.from(tfiles)));
    },
    [multiple, files],
  );
  const hasSelected = files.length > 0;
  return (
    <>
      <input
        className={classes.dNone}
        ref={inputEl}
        type="file"
        onChange={onFileChanged}
        accept={accept}
        multiple={multiple}
      />
      {hasSelected ? (
        <Button onClick={clearFile} buttonRef={btnEl} color="primary">
          {multiple ? `${files.length} Files` : get(files, '0.name', label)}
        </Button>
      ) : (
        <Button
          color={color || undefined}
          onClick={onClick}
          className={classes.root}
          buttonRef={btnEl}
          disabled={disabled}
        >
          {icon}
          {files.length === 0 || multiple ? label : get(files, '0.name', label)}
        </Button>
      )}
      <Popper
        id={ppId}
        open={open}
        anchorEl={get(btnEl, 'current')}
        className={classes.popper}
        placement="bottom"
      >
        <Paper className={classes.popContent}>
          {files.map((file, ii) => {
            return (
              <React.Fragment key={ii}>
                <Typography className={classes.typography}>
                  {file.name}
                  <IconButton
                    color="primary"
                    onClick={() => setFileList(old => old.remove(ii))}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Typography>
              </React.Fragment>
            );
          })}
          {files && files.length > 0 && (
            <MButton
              variant="contained"
              color="secondary"
              size="large"
              fullWidth
              onClick={() => {
                onSelect && onSelect(files);
                // if (open) setPopOpened(false);
                setFileList(List([]));
              }}
            >
              Submit
            </MButton>
          )}
        </Paper>
      </Popper>
    </>
  );
}

export default withStyles(styles)(FileInput);
